import React, { Component } from "react";
import BsyIconBtn from "../BsyIconBtn";
import { BsyUtils } from "../../utils/Utils";
import BsyDateTime from "../BsyDateTime";
import BsyDateTimeLimit from "../BsyDateTimeLimit";
import BsySelect from "../BsySelect"
import BsyDialog from "../BsyDialog";
import BsyAlert from "../BsyAlert";
import BsySwitchBtn from "../BsySwitchBtn";
import BsyAlertListDetail from "../BsyAlertListDetail";
import UserViewDetailCont from "./UserViewDetailCont";
import BsyTurnPage from "../BsyTurnPage";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsySLoading from "../BsySLoading";
import { dayjsUtils } from "../../utils/dayjsUtils";

class OperationRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || {},
      selectVal: props.selectVal || {},
      projectId: props.projectId || "",
      dataList: [],
      timeLimit: [null, null],
      keyword: "",
      type: "0",
      skip: 0,
      count: 0,
      limit: 20,
      isLoading: true
    }
  }

  componentDidMount() {
    this.loadData();
  }

  skipChange = (e) => {
    this.setState({
      skip: e
    }, () => {
      this.loadData();
    })
  }

  listLimitChange = (e) => {
    this.setState({
      limit: e,
      skip: 0
    }, () => {
      this.loadData();
    })
  }

  loadData = () => {
    const { skip, limit, selectVal, data, type, keyword, timeLimit } = this.state;
    this.setState({ isLoading: true }, () => {
      React.axios("/dashboard/standard_user_operation_log", {
        data_id: data.data_id,
        _id: selectVal._id,
        skip: skip * limit,
        type,
        keyword,
        timeLimit,
        limit
      }).then(res => {
        const { list, count } = res.data;
        this.setState({ dataList: list, count, isLoading: false })
      })
    })
  }

  getContext = (e) => {
    this.timeDate = e;
  }

  typeText = (e) => {
    switch (e) {
      case "1":
        return React.language("add1");
      case "2":
        return React.language("postpone");
      case "3":
        return React.language("modify");
      case "4":
        return React.language("unbind.management");
      case "5":
        return React.language("disable");
      case "6":
        return React.language("recover");
      case "7":
        return React.language("Token.management");
      case "8":
        return React.language("update.management");
      default:
        return "";
    }
  }

  unbindSwitch = false;

  switchChange = (e) => {
    this.unbindSwitch = e;
  }

  render() {
    const { limit, skip, count, data, dataList, type, isLoading } = this.state;
    const { data_id, status } = data;
    return <div className="OperationRecord">
      <div className="contHeader">
        <span className="title">{React.language('data.operation.record')}</span>
        <i className="icon-close-large" onClick={() => {
          this.props.onRemoveRoot();
        }}></i>
      </div>
      <div className="contBody">
        <div className="body-top">
          <div className="operationTime">
            <div className="operationTitle">{React.language('Operating.time')}</div>
            <BsyDateTimeLimit
              width={400}
              height={32}
              value={{ max: null, min: null }}
              theme={this.props.theme}
              format={'yyyy-MM-dd HH:mm:ss'}
              width4number={'auto'}
              waterMark={React.language("placeholder.operating.time")}
              onStopEdit={e1 => {
                const t = this.timeDate.getValue();
                if (!BsyUtils.isNumber(t.min)) {
                  t.min = null
                } else {
                  t.min = t.min / 1000
                }
                if (!BsyUtils.isNumber(t.max)) {
                  t.max = null
                } else {
                  t.max = t.max / 1000
                }
                this.setState({ timeLimit: [t.min, t.max], skip: 0 }, () => {
                  this.loadData();
                })
              }}
              getContext={this.getContext}
            />
          </div>
          <div className="operationType">
            <div className="operationTitle">{React.language('Operating.type')}</div>
            <BsySelect
              theme={this.props.theme}
              allowBlank={false}
              width={180}
              height={34}
              value={type}
              hasSelectAll={false}
              hasSelectEmpty={false}
              items={[
                { value: "0", text: React.language("all") },
                { value: "1", text: React.language("add1") },
                { value: "2", text: React.language("postpone") },
                { value: "3", text: React.language("modify") },
                { value: "4", text: React.language("unbind.management"), customCls:"unbind-management-red" },
                { value: "5", text: React.language("disable") },
                { value: "6", text: React.language("recover") },
                { value: "7", text: React.language("Token.management") },
                { value: "8", text: React.language("update.management") },
              ]}
              onStopEdit={e1 => {
                this.setState({ type: e1, skip: 0 }, () => {
                  this.loadData();
                })
              }}
            />
          </div>
          <div className="operationSearch">
            <input type="text" maxLength={1024} placeholder={React.language("search.data.operation.record")} onChange={(e) => {
              this.searchTime && clearTimeout(this.searchTime);
              this.searchTime = setTimeout(() => {
                this.setState({ keyword: e.target.value, skip: 0 }, () => {
                  this.loadData();
                })
              }, 300)
            }} />
            <div className="searchIconBtn">
              <i className="icon-bsy-reportmenu-0"></i>
            </div>
          </div>
        </div>
        <div className="body-bottom">
          <div className="OperationRecordTable">
            {isLoading && <BsySLoading style={{ background: '#ffffff' }} />}
            <div className="table-content">
              <div className="content-header">
                <div className="header-tr">
                  <div className={`header-td time`}>{React.language("operating.time")}</div>
                  <div className={`header-td type`}>{React.language("type.operation")}</div>
                  <div className={`header-td cont`}>{React.language("operating.cont")}</div>
                </div>
              </div>
              <div className="content-body">
                {
                  dataList.map(res => {
                    return <div className="body-tr">
                      <div className={`body-td time`}>{BsyUtils.date2Str(dayjsUtils.timeToTZ(res.createTime), "yyyy-MM-dd HH:mm:ss")}</div>
                      <div className={`body-td type`}>{this.typeText(res.type)}</div>
                      <div className={`body-td cont`}>{res.content}</div>
                    </div>
                  })
                }
              </div>
            </div>
          </div>
          <BsyTurnPage skipChange={this.skipChange} listLimitChange={this.listLimitChange} limit={limit} skip={skip} count={count} />
        </div>
      </div>
      <div className="contFooter">
        <div className="left-group">
          <BsyIconBtn
            text={React.language("postpone")}
            click={(event) => {
              this.addPostponeDesc = "";
              BsyDialog({
                title: React.language('user.postpone'),
                height: 490,
                width: 460,
                okText: React.language("save"),
                cancelText: React.language("cancel"),
                onContentCreate: () => {
                  const { expireTime } = this.state.data;
                  return <div className={"addProjectContent"}>
                    <div className="addItem name">
                      <div className="itemTitle">
                        <span>{React.language('postpone.time')}</span>
                        <span className="itemMsg">{React.language('maturity.time.msg')}</span>
                      </div>
                      <div className="itemValue">
                        <BsyDateTime
                          key={"BsyDateTimeLimit" + new Date().getTime()}
                          width={'100%'}
                          height={36}
                          value={expireTime ? new Date(expireTime).getTime() : null}
                          theme={this.props.theme}
                          format={'yyyy-MM-dd HH:mm:ss'}
                          width4number={'auto'}
                          waterMark={React.language("placeholder.postpone.time")}
                          onStopEdit={e1 => {
                            this.maturityTime = e1;
                          }}
                          getContext={this.getTimeContext}
                        />
                      </div>
                    </div>
                    <div className="addItem remark">
                      <div className="itemTitle">
                        <span>{React.language('postpone.note')}</span>
                      </div>
                      <div className="itemValue">
                        <textarea maxLength={1024} onChange={this.addChangePostponeDesc}
                          placeholder={React.language("placeholder.postpone.note")} />
                      </div>
                    </div>
                  </div>
                },
                onOk: () => {
                  React.axios("/dashboard/standard_user_update", { _id: this.state.projectId, data_id, expireRemark: this.addPostponeDesc, expireTime: this.maturityTime ? this.maturityTime / 1000 : "" }).then((res) => {
                    if (res.data.code === 200) {
                      this.state.data.expireTime = this.addProjectDesc;
                      let t = "";
                      if (this.maturityTime) {
                        const d = new Date(this.maturityTime);
                        t += d.getFullYear() + "-";
                        t += (d.getMonth() + 1) + "-";
                        t += d.getDate() + " ";
                        t += d.getHours() + ":";
                        t += d.getMinutes() + ":";
                        t += d.getSeconds();
                      } else {
                        t = null;
                      }
                      this.state.data.expireTime = t;
                      this.setState({ data: this.state.data });
                      tipAlert({
                        type: "success",
                        msg: React.language("update.success")
                      })
                    }

                    this.props.userManagementContext.loadData();
                  })
                }
              })
            }}
            type={"white borderBlue"}
            mode={window.mode}
          />
          <BsyIconBtn
            key={status}
            text={status === "5" ? React.language("restore") : React.language("disable")}
            click={(event) => {
              BsyAlert({
                title: status === "5" ? React.language("query.restore.title", { name: data.username }) : React.language("query.disable.title", { name: data.username }),
                // msg: status === "5" ? "" : React.language("query.disable.msg"),
                type: "query",
                iconColor: status === "5" ? "#0265ff" : "var(--bsy-base-error-color)",
                text4Ok: React.language("ok"),
                OkType: status === "5" ? "blue" : "pureRed",
                text4Cancel: React.language("cancel"),
                ok: () => {
                  let d = {};
                  if (status === "5") {
                    d = { _id: this.state.projectId, data_id, restore: true }
                  } else {
                    d = { _id: this.state.projectId, data_id, forbid: true }
                  }
                  React.axios("/dashboard/standard_user_update", d).then((res) => {
                    if (res.data.code === 200) {
                      this.state.data.status = res.data.status;
                      this.setState({ data: this.state.data })
                      tipAlert({
                        type: "success",
                        msg: React.language("update.success")
                      })
                    }

                    this.props.userManagementContext.loadData();
                  })
                }
              })
            }}
            type={status === "5" ? "white borderBlue" : "red"}
            mode={window.mode}
          />
          <BsyIconBtn
            text={React.language("project.user.detail")}
            click={(event) => {
              this.props.onRemoveRoot()
              BsyAlertListDetail({
                type: "custom",
                width: 1000,
                createContent: (e) => {
                  return <UserViewDetailCont selectVal={this.state.selectVal} userManagementContext={this.props.userManagementContext} projectId={this.state.projectId} data={data} onRemoveRoot={e.props && e.props.onRemoveRoot} />
                }
              })
            }}
            type={"white borderBlue"}
            mode={window.mode}
          />
        </div>

        {/*<BsyIconBtn*/}
        {/*  text={React.language("unbind.management")}*/}
        {/*  click={(event) => {*/}
        {/*    BsyDialog({*/}
        {/*      title: React.language('unbind.management'),*/}
        {/*      height: 290,*/}
        {/*      width: 460,*/}
        {/*      okText: React.language("ok"),*/}
        {/*      cancelText: React.language("cancel"),*/}
        {/*      onContentCreate: () => {*/}
        {/*        return <div className={"unbindManagementContent"}>*/}
        {/*          <div className="contLine">*/}
        {/*            <div className="lineTitle">{React.language('unbind.management')}</div>*/}
        {/*            /!*<BsySwitchBtn switchChange={this.switchChange} power={status !== "3"} />*!/*/}
        {/*          </div>*/}
        {/*          <div className="lineMsg">*/}
        {/*            {React.language('unbind.management.msg')}*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      },*/}
        {/*      onOk: () => {*/}
        {/*        React.axios("/dashboard/standard_user_update", {_id: this.state.projectId, data_id, unbind: true}).then((res) => {*/}
        {/*          if (res.data.code === 200) {*/}
        {/*            this.state.data.status = res.data.status;*/}
        {/*            this.setState({data: this.state.data})*/}
        {/*            tipAlert({*/}
        {/*              type: "success",*/}
        {/*              msg: React.language("update.success")*/}
        {/*            })*/}
        {/*          }*/}

        {/*          this.props.userManagementContext.loadData();*/}
        {/*        })*/}
        {/*      }*/}
        {/*    })*/}
        {/*  }}*/}
        {/*  type={"red"}*/}
        {/*  mode={window.mode}*/}
        {/*/>*/}

      </div>
    </div>
  }
}

export default OperationRecord;